// assets.
import completedDotIcon from '../../assets/icons/completed-dot.svg';
import dotIcon from '../../assets/icons/pending-dot.svg';
import progressDotIcon from '../../assets/icons/progress-dot.svg';

export const statusLabel: Record<string, JSX.Element> = {
  completed: (
    <div className="d-flex  gap-1 justify-content-center">
      <img src={completedDotIcon} />
      Finalizado
    </div>
  ),
  pending: (
    <div className="d-flex gap-1 justify-content-center">
      <img src={dotIcon} />
      Pendiente
    </div>
  ),
  progress: (
    <div className="d-flex gap-1 justify-content-center">
      <img src={progressDotIcon} />
      En progreso
    </div>
  ),
  rejected: (
    <div className="d-flex gap-1 justify-content-center">
      <img src={progressDotIcon} />
      Rechazado
    </div>
  ),
};

export const statusText: Record<string, string> = {
  pending: 'Pendiente',
  progress: 'En progreso',
  completed: 'Finalizado',
  rejected: 'Rechazado',
};

export const ALL_STATUS_OPTIONS = Object.entries(statusText).map(
  ([value, label]) => ({ value, label })
);

export const UNASSIGNED_AGENT = 'Sin asignar';

export const getOptionsFromData = (
  data: any[],
  key: 'agent'
): { label: string; value: string }[] => {
  const values = new Set(data.map(item => item[key] || UNASSIGNED_AGENT));
  return Array.from(values).map(value => ({ label: value, value }));
};
